import React from 'react';
import Grid from '@material-ui/core/Grid';
import { CssBaseline } from '@material-ui/core';
function ErrorUnauthorized() {
    return (React.createElement(Grid, { container: true, justify: "center", spacing: 2 },
        React.createElement(CssBaseline, null),
        React.createElement("div", { style: { textAlign: 'center', paddingTop: '120px' } },
            React.createElement("p", null,
                React.createElement("strong", null, "Unauthorized Error")),
            React.createElement("p", null,
                "Unexpected error during the authentication process.",
                React.createElement("br", null),
                "Please contact support at 1-800-MICHELIN to correct this issue.",
                React.createElement("br", null),
                "Or try to login again:",
                ' ',
                React.createElement("a", { href: window.location.origin }, "here")))));
}
export default ErrorUnauthorized;
//# sourceMappingURL=ErrorUnauthorized.js.map